export default {
  outbound: 'Utgående',
  inbound: 'Returflyg',
  hide: 'Dölj',
  details: 'Detaljer',
}
